import React from "react"
import { motion } from "framer-motion"
import { useColors } from "@mallardbay/lib-react-components"

import AssistantPanelContent from "~components/outfitter-assistant/assistant-panel-content"
import AnimatedPanel from "~components/shared/motion/animated-panel"
import { componentStylesCss } from "~utils/helpers/style-helpers"
import { TEST_IDS } from "~config/constants"
import {
    ASSISTANT_PANE_WIDTH,
    OUTFITTER_ASSISTANT_EXCLUDE_ATTR,
} from "~components/outfitter-assistant/outfitter-assistant-constants"
import {
    ASSISTANT_DESKTOP_PANEL_VARIANTS,
    ASSISTANT_PANE_WIDTH_VARIANTS,
} from "~components/outfitter-assistant/assistant-presentation-motion"

const EXCLUDE_PROPS = { [OUTFITTER_ASSISTANT_EXCLUDE_ATTR]: "" } as const

export default function AssistantPanel() {
    const styles = useStyles()

    return (
        <motion.div
            variants={ASSISTANT_PANE_WIDTH_VARIANTS}
            initial="initial"
            animate="animate"
            exit="exit"
            style={styles.paneSlot}
        >
            <AnimatedPanel
                style={styles.panel}
                testId={TEST_IDS.OUTFITTER_ASSISTANT_PANEL}
                variants={ASSISTANT_DESKTOP_PANEL_VARIANTS}
                transformOrigin="center right"
                {...EXCLUDE_PROPS}
            >
                <AssistantPanelContent />
            </AnimatedPanel>
        </motion.div>
    )
}

function useStyles() {
    const colors = useColors()

    return componentStylesCss({
        paneSlot: {
            flexShrink: 0,
            height: "100%",
            overflow: "hidden",
        },
        panel: {
            backgroundColor: colors.bg,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            flexShrink: 0,
            width: ASSISTANT_PANE_WIDTH,
            maxWidth: "100vw",
            height: "100%",
            borderLeft: `1px solid ${colors.border}`,
        },
    })
}
